var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "#55C043",
    stroke: "#55C043"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59391 13C6.5469 13 6.50071 12.9878 6.45991 12.9647C6.41912 12.9415 6.38514 12.9082 6.36134 12.868C5.46529 11.3546 3.07644 8.1321 3.05244 8.09972C3.01407 8.048 2.99575 7.98432 3.00083 7.92031C3.00592 7.8563 3.03407 7.79625 3.08014 7.75112L3.8147 7.03146C3.85957 6.98751 3.91855 6.96054 3.98139 6.95524C4.04424 6.94994 4.10696 6.96665 4.15867 7.00245L6.53779 8.64935C8.12978 6.62549 9.60856 5.22723 10.5814 4.40216C11.6767 3.47343 12.374 3.05532 12.4032 3.0381C12.4451 3.01317 12.493 3 12.5419 3H13.7303C13.785 3 13.8384 3.01647 13.8834 3.04723C13.9284 3.07799 13.9629 3.12158 13.9824 3.17224C14.0018 3.22289 14.0053 3.27821 13.9923 3.33086C13.9793 3.38351 13.9505 3.431 13.9096 3.46704C10.5349 6.44706 6.8649 12.8011 6.82823 12.865C6.80481 12.9057 6.771 12.9396 6.73017 12.9633C6.68935 12.987 6.64296 12.9997 6.59566 13L6.59391 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveTick);
export default __webpack_public_path__ + "static/media/approve_tick.1f15c7cf6b4a6f78868902ce568b1ab1.svg";
export { ForwardRef as ReactComponent };